exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-information-settings_card-item {\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0,0,0,0.1);\n  transition: box-shadow 0.3s ease-in-out;\n  position: relative;\n}\n.profile-information-settings_card-item:hover {\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0,0,0,0.32);\n}\n.profile-information-settings_item-remove {\n  position: absolute;\n  bottom: 16px;\n  right: 16px;\n}\n.profile-information-settings_item {\n  font-size: 1rem;\n}\n.profile-information-settings_item--bold {\n  font-weight: bold;\n  font-size: 1rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/pages/profile/views/work/styles/styles.styl
// module id = 2dfbad9da18f677ddd03
// module chunks = 27